import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-column-filter-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './column-filter-dialog.component.html',
  styleUrl: './column-filter-dialog.component.css'
})
export class ColumnFilterDialogComponent {
  availableFields: string[] = [];
  selectedFields: string[] = [];
  selectedAvailableField: string | null = null;
  selectedSelectedField: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<ColumnFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { availableFields: string[]; selectedFields: string[] }
  ) {
    this.availableFields = data.availableFields;
    this.selectedFields = []; // Ensure selectedFields is initially empty
  }

  moveFieldToSelected(): void {
    if (this.selectedAvailableField) {
      this.selectedFields.push(this.selectedAvailableField);
      this.availableFields = this.availableFields.filter(
        (field) => field !== this.selectedAvailableField
      );
      this.selectedAvailableField = null;
    }
  }

  moveFieldToAvailable(): void {
    if (this.selectedSelectedField) {
      this.availableFields.push(this.selectedSelectedField);
      this.selectedFields = this.selectedFields.filter(
        (field) => field !== this.selectedSelectedField
      );
      this.selectedSelectedField = null;
    }
  }

  moveFieldToSelectedAll(): void {
    this.selectedFields = this.selectedFields.concat(this.availableFields);
    this.availableFields = [];
  }

  moveFieldToAvailableAll(): void {
    this.availableFields = this.availableFields.concat(this.selectedFields);
    this.selectedFields = [];
  }

  moveFieldUp(): void {
    const index = this.selectedFields.indexOf(this.selectedSelectedField!);
    if (index > 0) {
      [this.selectedFields[index - 1], this.selectedFields[index]] = [
        this.selectedFields[index],
        this.selectedFields[index - 1],
      ];
    }
  }

  moveFieldDown(): void {
    const index = this.selectedFields.indexOf(this.selectedSelectedField!);
    if (index < this.selectedFields.length - 1) {
      [this.selectedFields[index + 1], this.selectedFields[index]] = [
        this.selectedFields[index],
        this.selectedFields[index + 1],
      ];
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close(this.selectedFields);
  }
}

